import { DuplicateRecoveryInformationContainer } from "../../../containers/borrowSystem/ProposedToTheSubCommittee/DuplicateRecoveryInformationContainer";

export function DuplicateRecoveryInformationPage () {

    return(
        <DuplicateRecoveryInformationContainer/>
    )
}




